import React, { useState } from 'react';
import Button from '../../components/button';
import InputButton from '../../components/input-button';
import Anchor from '../../components/anchor';

import handleChat, { sendNumber } from '../../utils/handle-chat';
import handleGa from '../../utils/handle-ga';

const waihuList = [
  { title: '工作台一键外呼', text: '对话过程不顺畅，客户理解不到位，“一言不合” 打电话，坐席果断出击，高效沟通，客户服务更满意' },
  { title: '针对性电话营销', text: '通过顾客中心的有效留电发起外呼，售前主动营销，转化潜在客户，售后定期回访，满足企业多种外呼场景需求' },
  { title: '一站式管理', text: '监控&数据&质检统一管理，实时状态监控，提升服务质量；多维度数据分析，业务情况全面掌控' }
];

const audioList = [
  { title: '高效沟通', text: '客户总是希望快速响应，使用实时语音和视频聊天提供一对一帮助，快速解决问题，提高客户满意度' },
  { title: '个性化服务', text: '现代聊天只是打字怎么行？一键语音或视频聊天，立即与你的客户紧密联系，为客户提供独特的服务体验' },
  { title: '建立信任关系', text: '提供个性化聊天方式让客户参与其中，良好的客户体验可以建立更深层此的信任关系，从而提高客户参与度和转化率' }
];

const formList = [
  { title: '多渠道、多场景触达', text: '通过网页嵌入、独立链接、小程序等多种渠道收集客户信息，利用短信、邮件、电话等多形式触达客户，建立客户关系' },
  { title: '自定义外观', text: '丰富的模板样式，覆盖不同行业和业务场景的个性化需求，每一处细节都为你精细把控，高品质高回馈' },
  { title: '高级数据分析', text: '回收数据实时在线统计，支持多维度筛选和数据导出，自动生成专业数据分析报告，了解客户真实声音' }
];

const weixinList = [
  { title: '主动推送，激活新粉', text: '主动问候，激活微信公众号新粉丝，唤醒沉默用户，自动打标签，在最佳时机，推送优质模板消息，转化变现一步到位' },
  { title: '多种场景，自动化营销', text: '设置自动化营销旅程，在合适的时间给合适的客户发送合适的消息，从客户进入的第一步开始，每一步都无比精确' },
  { title: '微信机器人，永远在线', text: '聊天机器人7×24小时全天候服务，抓住48小时与公众号互动的粉丝，持续互动，营销不间断' }
];

const duokeList = [
  { title: '风控管理，实时监督', text: '微信聊天记录实时备份，敏感词监控设置，离职员工客户再分配，客户异动立即通知，违规操作及时提醒' },
  { title: '客服工具，多方辅助', text: '多类型消息分类管理，快捷回复一键发送，支持不同渠道发放客服二维码，帮助企业统计推广效果' },
  { title: '客户专属名片，广泛营销', text: '为每一位客户生成专属名片，统计不同客户的邀请数据，让客户参与营销，实现高效运营' }
];

const topList = [
  { icon: 'icon-more-channel', title: '多渠道一键集成', text: '移动App、网页端、微信、微博、今日头条、快手…在客户可能出现的任何地方，快速建立沟通渠道' },
  { icon: 'icon-more-dingzhi', title: '按需定制功能', text: '针对企业不同需求，提供定制化解决方案，基础产品+功能自由组合购买，付费方式更灵活' },
  { icon: 'icon-more-system', title: '深度集成企业自有系统', text: '统一接口，双向同步，深度集成全面传递信息，提升人工服务效率，更懂客户更懂你' },
  { icon: 'icon-more-message', title: '对话高效接待，消息稳定收发', text: '多种分配条件，智能分配潜在客户，快捷回复、询前表单、内部知识库…客户问题快速响应' }
];

const Content = () => {
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState(false);
  const handlePhone = () => {
    if (!/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(phone)) {
      setPhoneError(true);
      return;
    }
    const content = `15天免费试用，手机号：${phone}`;
    setPhoneError(false);
    sendNumber(phone);
    handleChat(content, ['c5', 'type2']);
  };
  return (
    <>
      <div className="content">
        <div className="btn_group">
          <Button size="large" type="primary" href="#detail" onClick={() => handleGa('立即购买', ['详情', '在线客服'])}>
            立即购买
          </Button>
          <Button size="large" href="#detail" onClick={() => handleGa('查看详情', ['详情', '在线客服'])}>
            查看详情
          </Button>
        </div>
        <div>
          <div component="ul" className="online-list">
            {topList.map((item, i) => {
              const { icon, title, text } = item;
              return (
                <li key={`${i}`}>
                  <i className={`content-icon ${icon}`} />
                  <div className="content-title">{title}</div>
                  <div className="content-text">{text}</div>
                </li>
              );
            })}
          </div>
          <div>
            <div className="content-icon-top" />
          </div>
        </div>

        <div>
          <Anchor id="call-plugin" />
          <div>
            <h1>外呼插件</h1>
            <h2>集成在线客服，更近一步连接你的客户</h2>

            <div className="btn_group">
              <Button size="large" type="primary" onClick={() => handleChat('立即购买外呼插件', ['c1', 'type1'])}>
                立即购买
              </Button>
              <Button size="large" onClick={() => handleChat('免费试用外呼插件', ['c1', 'type2'])}>
                免费试用
              </Button>
            </div>
          </div>
          <div className="content-group info reverse">
            <div className="content-group-item">
              <div component="i" className="icon-waihu" />
            </div>
            <div className="content-group-item">
              <div component="div" className=" content-text-list">
                <ul>
                  {waihuList.map((item, index) => {
                    const { title, text } = item;
                    return (
                      <li key={`${index}`}>
                        <div className="content-title">{title}</div>
                        <div className="content-text">{text}</div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div>
          <Anchor id="audio-video" />
          <div>
            <h1>音视频通讯</h1>
            <h2>支持客户与员工的实时语音视频聊天</h2>
            <div className="btn_group">
              <Button size="large" type="primary" onClick={() => handleChat('立即购买音视频通讯', ['c2', 'type1'])}>
                立即购买
              </Button>
              <Button size="large" onClick={() => handleChat('免费试用音视频通讯', ['c2', 'type2'])}>
                免费试用
              </Button>
            </div>
          </div>

          <div className="content-group info">
            <div className="content-group-item">
              <div component="div" className="left content-text-list">
                <ul>
                  {audioList.map((item, index) => {
                    const { title, text } = item;
                    return (
                      <li key={`${title}_${index}`}>
                        <div className="content-title">{title}</div>
                        <div className="content-text">{text}</div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="content-group-item">
              <div component="i" className="icon-audio" />
            </div>
          </div>
        </div>

        <div>
          <Anchor id="online-form" />
          <div>
            <h1>在线表单</h1>
            <h2>多渠道收集客户诉求，及时通知企业进行跟进</h2>

            <div className="btn_group">
              <Button size="large" type="primary" onClick={() => handleChat('立即购买在线表单', ['c3', 'type1'])}>
                立即购买
              </Button>
              <Button size="large" onClick={() => handleChat('免费试用在线表单', ['c3', 'type2'])}>
                免费试用
              </Button>
            </div>
          </div>

          <div className="content-group info reverse">
            <div className="content-group-item">
              <div component="i" className="icon-form" />
            </div>
            <div className="content-group-item">
              <div component="div" className=" content-text-list">
                <ul>
                  {formList.map((item, index) => {
                    const { title, text } = item;
                    return (
                      <li key={`${title}_${index}`}>
                        <div className="content-title">{title}</div>
                        <div className="content-text">{text}</div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div>
          <Anchor id="wechat-agent" />
          <div>
            <h1>微信客服</h1>
            <h2>深度对接微信生态，激活公众号粉丝</h2>

            <div className="btn_group">
              <Button size="large" type="primary" onClick={() => handleChat('立即购买微信客服', ['c4', 'type1'])}>
                立即购买
              </Button>
              <Button size="large" onClick={() => handleChat('免费试用微信客服', ['c4', 'type2'])}>
                免费试用
              </Button>
            </div>
          </div>

          <div className="content-group info">
            <div className="content-group-item">
              <div component="div" className="left content-text-list">
                <ul>
                  {weixinList.map((item, index) => {
                    const { title, text } = item;
                    return (
                      <li key={`${title}_${index}`}>
                        <div className="content-title">{title}</div>
                        <div className="content-text">{text}</div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="content-group-item">
              <div component="i" className="icon-weixin" />
            </div>
          </div>
        </div>

        <div>
          <Anchor id="duoke-assistant" />
          <div>
            <h1>多客助手</h1>
            <h2>精细化运营，增强企业微信管理能力</h2>

            <div className="btn_group">
              <Button size="large" type="primary" onClick={() => handleChat('立即购买多客助手', ['c6', 'type1'])}>
                立即购买
              </Button>
              <Button size="large" onClick={() => handleChat('免费试用多客助手', ['c6', 'type2'])}>
                免费试用
              </Button>
            </div>
          </div>

          <div className="content-group info reverse">
            <div className="content-group-item">
              <div component="i" className="icon-duoke" />
            </div>
            <div className="content-group-item">
              <div component="div" className="left content-text-list">
                <ul>
                  {duokeList.map((item, index) => {
                    const { title, text } = item;
                    return (
                      <li key={`${title}_${index}`}>
                        <div className="content-title">{title}</div>
                        <div className="content-text">{text}</div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-title">
          <div>立即开启15天免费试用！</div>
        </div>
        <InputButton
          key="btn"
          className={phoneError ? 'error' : ''}
          placeholder="请输入你的手机号"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          onSubmit={handlePhone}>
          免费试用
        </InputButton>
      </div>
      <footer className="com-info">
        <div className="com-intro">
          <div>
            <p>关于我们</p>
            <p>
              匠人来了科技成都有限公司旗下品牌：
              <br />
              多客，为企业提供多种营销产品及方案，致力于创造企业与用户之间的新型互动方式
            </p>
          </div>
          <div>
            <p>联系我们</p>
            <p>
              电话：173 1867 7847
              <br />
              地址：成都市高新区天府大道中段666号希顿国际广场B座3806号
            </p>
          </div>
        </div>
        <div className="copyright">
          Copyright © 2020 匠人来了科技成都有限公司
          <a target="_blank" rel="noopener noreferrer" href="http://sc.beian.miit.gov.cn">
            蜀ICP备20004120号
          </a>
        </div>
      </footer>
    </>
  );
};

export default Content;
